import api from './serviceApi';

const paymentApi = {
  /**
   * Validate a credit card number and return brand information
   * @param {string} cardNumber
   * @returns {Promise<{ Valid: boolean, Brand: string|null, Errors: string[] }>} 
   */
  validateCard: async (cardNumber) => {
    try {
      const payload = { CardNumber: String(cardNumber || '').replace(/\D/g, '') };
      const response = await api.post('/Payment/validate/card', payload);
      return response.data;
    } catch (error) {
      // Normalize error shape similar to API contract for callers
      const fallback = { Valid: false, Brand: null, Errors: [] };
      if (error?.response?.data) return { ...fallback, ...error.response.data };
      return fallback;
    }
  },
};

export default paymentApi;

